<template>
  <div>
    <img
      v-if="reviewStore.settings.experienceReviewImageUrl"
      class="h-20 mx-auto object-contain rounded-lg mt-2"
      :src="reviewStore.settings.experienceReviewImageUrl"
      alt="Law Logo"
    />
    <div class="my-4">
      <h2>
        How was your experience with {{ reviewStore.settings.companyName }}?
      </h2>
    </div>
    <div class="flex justify-center items-center w-full">
      <el-rate
        class="flex lg:w-1/4"
        :style="{ fontSize: '20rem', height: '10rem' }"
        v-model="rateValue"
        size="large"
        :texts="['Oops', 'Disappointed', 'Average', 'Great', 'Excellent']"
        show-text
      />
    </div>
    <div
      class="flex justify-center w-full"
      v-if="rateValue <= 4 && reviewStore.settings.captureComment"
    >
      <div class="w-2/3">
        <el-input
          v-model="textarea"
          :autosize="{ minRows: 2, maxRows: 30 }"
          type="textarea"
          placeholder="What could we have done better?"
        />
      </div>
    </div>
    <div class="flex justify-center w-full my-4">
      <el-button type="success" size="large" plain @click="submitRating"
        >Continue</el-button
      >
    </div>
  </div>
</template>
<script setup>
import { useReview } from "@/stores";
const reviewStore = useReview();
import api from "@/composables/api";
import { ref, onMounted } from "vue";

const rateValue = ref(5);
const textarea = ref("");

const submitRating = () => {
  // reviewStore.recordClick("starChoiceClicked", rateValue.value);
  api(`v1/review/submit/${reviewStore.hashId}`, {
    method: "POST",
    body: {
      rating: rateValue.value,
      comment: textarea.value,
    },
  }).then((res) => {
    reviewStore.reviewStatus = "reviewed";
    if (rateValue.value > 4 && reviewStore.settings.feedbackQuestion) {
      reviewStore.currentComponent = "FeedbackRequest";
    } else if (reviewStore.invoiceStatus === "unpaid") {
      reviewStore.currentComponent = "PaymentOptions";
    } else {
      reviewStore.currentComponent = "ThankYou";
    }
  });
};

onMounted(() => {
  // Wait for the next frame to ensure that all elements are rendered
  requestAnimationFrame(() => {
    // Query the star elements; adjust the query to match your actual DOM structure
    const starElements = document.querySelectorAll(".el-rate .el-rate__icon");

    // Loop through the NodeList and adjust the styles
    starElements.forEach((starElement) => {
      starElement.style.fontSize = "50px";
    });
  });
});
</script>
<style scoped></style>
